import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { PROJECT_API } from "../apiRoutes";

interface UseGetProjectByIdProps {
  id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getProjectById = async (id: string) => {
  return await axiosAuth.get(`${PROJECT_API}/${id}`);
};

const useGetProjectById = ({
  id,
  queryParams,
}: UseGetProjectByIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["project", id],
    queryFn: () => getProjectById(id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetProjectById;
